import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Text, IconTick, Box } from 'braid-design-system';
import { observer } from 'mobx-react';

import { TimeAgo } from 'src/components/common/TimeAgo';

import HotjarMask from '../../common/HotjarMask';
import SyncMessage from '../../common/SyncMessage';

import translations from './.vocab';
interface Props {
  from: string;
  isNew: boolean;
  markAsNotNew: () => void;
  dateSent: string;
  locale: Locale;
}

const EmailItemMeta = ({
  from,
  isNew,
  locale,
  dateSent,
  markAsNotNew,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Box
      display="flex"
      alignItems="center"
      paddingBottom="medium"
      style={{
        paddingTop: '6px',
      }}
    >
      <Text size="xsmall" tone="secondary">
        <HotjarMask>
          {`${from}\u00A0\u00A0`}•{`\u00A0\u00A0`}
        </HotjarMask>
      </Text>
      <div data-testid="sent-date">
        <SyncMessage
          message={
            <Text tone="positive" size="xsmall">
              <IconTick /> {t('Sent')}
            </Text>
          }
          showMessage={isNew}
          onHide={() => markAsNotNew()}
        >
          <Text size="xsmall" tone="secondary">
            <TimeAgo date={dateSent} locale={locale} size="xsmall" />
          </Text>
        </SyncMessage>
      </div>
    </Box>
  );
};

export default observer(EmailItemMeta);
